<template>
  <v-container column>
    <v-layout row align-center>

      <ima-logo />
      <v-spacer></v-spacer>
      <settings-menu/>
      <account-dropdown/>
    </v-layout>
  </v-container>
</template>

<script>
import AccountDropdown from '@/components/base/AccountDropdown';
import SettingsMenu from '@/components/base/SettingsMenu';
import ImaLogo from "@/components/base/ImaLogo";

export default {
  name: 'AdminHeader',
  components: {
    AccountDropdown,
    SettingsMenu,
    ImaLogo,
  },
};
</script>

<style scoped lang="scss">

  .container{
    max-width: 100% !important;
    padding: 0 !important;
  }
</style>
